<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form"    >

        <!-- <a-form-item label="删除状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'delFlag', validatorRules.delFlag]" placeholder="请输入删除状态"></a-input>
        </a-form-item> -->
        <!-- <a-form-item :read-only="true" label="主任务id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'taskId', validatorRules.taskId]" placeholder="请输入主任务id"></a-input>
        </a-form-item>
        <a-form-item :read-only="true" label="子任务id" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'taskDetailId', validatorRules.taskDetailId]" placeholder="请输入子任务id"></a-input>
        </a-form-item> -->
        <a-form-item label="检查人编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'checkUserNo', validatorRules.checkUserNo]" placeholder="请输入检查人编码"></a-input>
        </a-form-item>
        <a-form-item label="检查人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'checkUserName', validatorRules.checkUserName]" placeholder="请输入检查人姓名"></a-input>
        </a-form-item>
        <a-form-item label="行为督查类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'actionType_dictText', validatorRules.actionType_dictText]" placeholder="请输入行为督查类型"></a-input>
        </a-form-item>
        <a-form-item label="违规地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'inspectionWhere', validatorRules.actionType_dictText]" placeholder="请输入行为督查类型"></a-input>
        </a-form-item>
        <a-form-item label="违规部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'illegalDepart', validatorRules.illegalDepart]" placeholder="请输入违规部门"></a-input>
        </a-form-item>
        <a-form-item label="违规区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input :read-only="true" v-decorator="[ 'illegalWorkshop', validatorRules.illegalWorkshop]" placeholder="请输入违规区域"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input type="textarea" :read-only="true" v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'

  export default {
    name: "BusInspectionActionExposureModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          delFlag: {rules: [
          ]},
          taskId: {rules: [
          ]},
          taskDetailId: {rules: [
          ]},
          checkUserNo: {rules: [
          ]},
          checkUserName: {rules: [
          ]},
          workerUserNo: {rules: [
          ]},
          workerUserName: {rules: [
          ]},
          actionType: {rules: [
          ]},
          illegalDepart: {rules: [
          ]},
          illegalWorkshop: {rules: [
          ]},
          remarks: {rules: [
          ]},
        },
        url: {
          add: "/general/actionexposure/busInspectionActionExposure/add",
          edit: "/general/actionexposure/busInspectionActionExposure/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.model.inspectionWhere=this.model.inspectionDepart+this.model.inspectionWorkshop
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'delFlag','taskId','taskDetailId','checkUserNo','checkUserName','workerUserNo','workerUserName','actionType_dictText',"inspectionWhere",'illegalDepart','illegalWorkshop','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        // 
        this.close()
        return
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'delFlag','taskId','taskDetailId','checkUserNo','checkUserName','workerUserNo','workerUserName','actionType','illegalDepart','illegalWorkshop','remarks'))
      },

      
    }
  }
</script>